package com.downdogapp.client.views.start

import com.downdogapp.client.AbstractView
import com.downdogapp.client.View

actual class OfflinePracticesPageView : AbstractView(), View {

  override val root
    get() = TODO("Not yet implemented")

  actual fun refreshView() {
    TODO("Not yet implemented")
  }
}